import { baseApi } from "./baseApi";

export const justificatifApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({

    // ✅ Route /coach/justificatifs commentée → n'existe plus
    // Coach ne peut plus lister les justificatifs
    getCoachJustificatifs: builder.query({
      queryFn: () => ({ data: { data: [], total: 0, current_page: 1, last_page: 1 } }),
      providesTags: ["Justificatifs"],
    }),

    getCoachJustificatifsStats: builder.query({
      queryFn: () => ({ data: { total: 0, approved: 0, rejected: 0, pending: 0 } }),
      providesTags: ["Justificatifs"],
    }),

    // ✅ Historique justificatifs stagiaire
    getStagiaireJustificatifs: builder.query({
      query: ({ page = 1, per_page = 10 } = {}) => ({
        url: "/stagiaire/justificatifs",
        params: { page, per_page },
      }),
      providesTags: ["Justificatifs"],
      transformResponse: (response) => {
        // Backend retourne { message, data: { data: [...], ... } }
        if (response?.data?.data) return response.data.data;
        if (Array.isArray(response?.data)) return response.data;
        if (Array.isArray(response)) return response;
        return [];
      },
    }),

    // ✅ Upload justificatif stagiaire
    uploadJustificatif: builder.mutation({
      query: (formData) => ({
        url: "/stagiaire/justificatifs",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Justificatifs"],
    }),

    approveJustificatif: builder.mutation({
      query: ({ id, comment = "" }) => ({
        url: `/coach/justificatifs/${id}`,
        method: "POST",
        // ✅ ValiderJustificatifRequest attend 'statut'
        body: { statut: "approved", comment },
      }),
      invalidatesTags: ["Justificatifs"],
    }),

    rejectJustificatif: builder.mutation({
      query: ({ id, comment = "" }) => ({
        url: `/coach/justificatifs/${id}`,
        method: "POST",
        // ✅ ValiderJustificatifRequest attend 'statut'
        body: { statut: "rejected", comment },
      }),
      invalidatesTags: ["Justificatifs"],
    }),

    // ✅ Mutation unifiée — envoie 'statut' (confirmé par ValiderJustificatifRequest)
    validateJustificatif: builder.mutation({
      query: ({ id, statut, status, comment = "" }) => ({
        url: `/coach/justificatifs/${id}`,
        method: "POST",
        // ✅ Toujours envoyer 'statut' (pas 'status')
        body: { statut: statut || status, comment },
      }),
      invalidatesTags: ["Justificatifs"],
    }),

    // ✅ Download via route stagiaire
    downloadJustificatif: builder.query({
      query: (id) => `/stagiaire/justificatifs/${id}/download`,
    }),
  }),
});

export const {
  useGetCoachJustificatifsQuery,
  useGetCoachJustificatifsStatsQuery,
  useGetStagiaireJustificatifsQuery,
  useUploadJustificatifMutation,
  useApproveJustificatifMutation,
  useRejectJustificatifMutation,
  useValidateJustificatifMutation,
  useDownloadJustificatifQuery,
} = justificatifApi;